import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { persistor, store } from './store/store';
import { Provider } from 'react-redux';
import { AmplifyProvider, Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports';
import { PersistGate } from 'redux-persist/integration/react';

import 'react-toastify/ReactToastify.min.css';
import { BrowserRouter } from 'react-router-dom';
import CacheBuster from 'react-cache-buster';
import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';
import config from './config';
import { APP_ENVIRONMENT_PRODUCTION } from './constants/app';

if (process.env.REACT_APP_ENVIRONMENT === APP_ENVIRONMENT_PRODUCTION) {
    posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY || '', {
        api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        autocapture: true,
    });
}

Amplify.configure(awsConfig);
const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
    <>
        <React.StrictMode>
            <PostHogProvider client={posthog}>
                <AmplifyProvider>
                    <Authenticator.Provider>
                        <Provider store={store}>
                            <PersistGate loading={null} persistor={persistor}>
                                <BrowserRouter>
                                    <CacheBuster
                                        currentVersion={'1.0.1'}
                                        isEnabled={false}
                                        isVerboseMode={false}
                                        loadingComponent={<>Loading...</>}
                                        metaFileDirectory={'.'}
                                    >
                                        <App />
                                    </CacheBuster>
                                </BrowserRouter>
                            </PersistGate>
                        </Provider>
                    </Authenticator.Provider>
                </AmplifyProvider>
            </PostHogProvider>
        </React.StrictMode>
    </>,
);
